/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Audit_MoreInputs */

const cs_gdpr_audit_more = /** @type {(inputs: Gdpr_Audit_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načíst další`)
};

const en_gdpr_audit_more = /** @type {(inputs: Gdpr_Audit_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more`)
};

/**
* | output |
* | --- |
* | "Load more" |
*
* @param {Gdpr_Audit_MoreInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_more = /** @type {((inputs?: Gdpr_Audit_MoreInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_MoreInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_more(inputs)
	return cs_gdpr_audit_more(inputs)
});